'use client';
import styled, { keyframes } from 'styled-components';

export const StyledOnboardingIntro = styled.main`
  background: ${props => props.theme.colors.background.base};
  padding-top: ${props => props.theme.spacing(11)};
  width: 100vw;
  height: 100vh;
  overflow: hidden;

  @media ${props => props.theme.laptop} {
    display: flex;
    align-items: center;
    padding-top: ${props => props.theme.spacing(0)};
  }
`;

export const MobileHeader = styled.div`
  position: absolute;
  top: ${props => props.theme.spacing(10)};
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  gap: ${props => props.theme.spacing(6)};
  @media ${props => props.theme.laptop} {
    display: none;
  }
`;
export const DesktopHeader = styled.span`
  display: none;
  @media ${props => props.theme.laptop} {
    display: initial;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
  img {
    width: 100%;
  }
  @media ${props => props.theme.laptop} {
    width: 50%;
    img {
      object-fit: cover;
    }
  }
`;

export const DesktopImageContainer = styled.div`
  display: none;
  height: 100%;
  @media ${props => props.theme.laptop} {
    display: flex;
    img {
      height: 100vh !important;
    }
  }
`;
export const MobileImageContainer = styled.div`
  overflow: hidden;
  position: relative;

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const ButtonContainer = styled.div`
  z-index: 2;
  display: flex;
  position: absolute;
  top: ${props => props.theme.spacing(10)};
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;
  button {
    background-color: #e8e4d7;
    border: none;
  }
  @media ${props => props.theme.laptop} {
    top: 10px;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const Headline = styled.div`
  ${props => props.theme.typography.heading3};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  min-width: 270px;
  text-align: center;
  margin: auto;

  @media ${props => props.theme.laptop} {
    position: static;
    left: auto;
    transform: none;
    text-align: left;
    margin-top: ${props => props.theme.spacing(8)};
  }
`;

export const BodyWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  min-height: ${props =>
    props.$minHeight ? `${props.$minHeight}px` : '321px'};
  bottom: 0;
  width: 100%;
  padding: ${props => props.theme.spacing(11, 6)};
  gap: ${props => props.theme.spacing(4)};
  border-radius: 32px 32px 0 0;
  overflow: hidden;
  background-color: ${props => props.theme.colors.background.base};

  @media ${props => props.theme.laptop} {
    position: relative;
    width: 50%;
    justify-content: space-around;
    text-align: left;
    border-radius: 0;
    max-width: 340px;
    padding: 0;
    margin: auto;
    gap: ${props => props.theme.spacing(8)};
    padding-top: ${props => props.theme.spacing(20)};
  }
`;

export const Body = styled.p`
  ${props => props.theme.typography.button};
  color: ${props => props.theme.colors.get(props.$fontColor)};
  text-align: center;
  @media ${props => props.theme.laptop} {
    text-align: left;
  }
`;

// Discount Pop Up
const slideUp = keyframes`
  0% { transform: translateY(100%); opacity: 0; }
  10% { transform: translateY(0); opacity: 1; }
  95% { transform: translateY(0); opacity: 1; }
  100% { transform: translateY(50%); opacity: 0; }
  `;

export const PopUpBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => props.$alignment};
  ${props => props.theme.typography.heading6};
  height: 52px;
  position: fixed;
  bottom: 240px;
  margin: auto;
  width: 90%;
  background-color: ${props => props.theme.colors.get(props.$bgColor)};
  color: white;
  padding: 16px 32px 18px;
  border-radius: 16px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.3);
  animation: ${slideUp} 5s ease-in forwards;
  font-size: 1rem;
  z-index: 9999;
  max-width: 350px;
  svg {
    margin-right: 10px;
  }
  @media ${props => props.theme.laptop} {
    position: absolute;
    top: -80px;
    left: 10px;
  }
`;
